export const GOODSVIEW_FILE = 'GOODSVIEW_FILE';
// 更新
export const GOODSVIEW_UPDATE = 'GOODSVIEW_UPDATE';
